const FNV_OFFSET = 0xcbf29ce484222325n
const FNV_PRIME = 0x100000001b3n
const MASK64 = (1n << 64n) - 1n

/**
 * Deterministic 64-bit string hash (FNV-1a over the UTF-16 code units) as 16 hex digits; used for
 * the song order (spec §8). Stable across platforms and runs, uniform enough to shuffle a level's
 * songs per player.
 */
export function hashHex(input: string): string {
  let h = FNV_OFFSET
  for (let i = 0; i < input.length; i++) {
    const u = input.charCodeAt(i)
    h ^= BigInt(u & 0xff)
    h = (h * FNV_PRIME) & MASK64
    h ^= BigInt(u >> 8)
    h = (h * FNV_PRIME) & MASK64
  }
  return h.toString(16).padStart(16, '0')
}
